// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.projectsListFullDiv
{
    -webkit-user-select: none;
            user-select: none;
}

.projectsListInterneDiv
{
    
    background-color: var(--dialog-content-backcolor);
    color: white;
    border-radius : 8px;
    width: 100%;
    -webkit-user-select: none;
            user-select: none;
    height: calc(100% - 60px);
    border: solid;
    border-width: 2px;
    border-color: var(--default-icon-color);
    margin-top: 10px;

    

    

}

.projectsListTitle
{
    padding-top: 5px;
    background-color: var(--dialog-title-backcolor);
    border-top-left-radius : 8px;
    border-top-right-radius : 8px;
    color: white;
    height: 30px;
    font-size: 15px;
    text-align: center;
    
}
.projectsListTitleCloseButton
{
    width: 30px;
    background-color: transparent;
}
.projectsListTitleText
{
    background-color: transparent;
    width: calc(100% - 30px);
    height: 20px;
    overflow: hidden;

}


.projectsListButtonsDiv
{
    padding-top: 10px;
    padding-bottom: 5px;
    
    background-color: var(--dialog-buttons-backcolor);
    border-bottom-left-radius : 8px;
    border-bottom-right-radius : 8px;
    color: white;
    height: 30px;
    font-size: 15px;
    margin-top: 10px;
    text-align: right;
    
}




.projectslist-limit
{
    background-color: transparent;
    margin-top: 5px;
}

.projectslist-container-header-text
{
    display: absolute;
    overflow-y:hidden;
    height: 20px;
    width: 99.6%;
}


.projectslist-container-header
{
    display: absolute;
    height: 20px;
    width: 99.6%;
}

.projectslist-container-header::-webkit-scrollbar-track {
    background: #101010; /* color of the tracking area */
  }
  
.projectslist-container-header::-webkit-scrollbar-thumb {
    background-color: #151515; /* color of the scroll thumb */
    border-radius: 20px; /* roundness of the scroll thumb */
    border: 1px solid var(--default-icon-color); /* creates padding around scroll thumb */
  }

.projectslist-container-header::-webkit-scrollbar{
    width:12px;
}

.projectslist-container
{
    overflow-y: scroll;
    margin-top: 5px;
    width: 99.7%;
    height: calc(100% - 85px)
    
}



.projectslist-container::-webkit-scrollbar-track {
    background: #101010; /* color of the tracking area */
  }
  
.projectslist-container::-webkit-scrollbar-thumb {
    background-color: #151515; /* color of the scroll thumb */
    border-radius: 20px; /* roundness of the scroll thumb */
    border: 1px solid var(--default-icon-color); /* creates padding around scroll thumb */
  }

.projectslist-container::-webkit-scrollbar{
    width:12px;
}







/* ************** projectslist ****************************** */
.projectslist-projectsList {
    background-color: blue;
    
    width: 100%;
}

/* element Header *********************************** */
.projectslist-headerList
{
    background-color: #404040;
    color: white;
    font-size:14px;
    text-align: center;
    padding-left: 2px;
    padding-right: 2px;
    padding-top: 1px;

    border-radius: 5px;
    height: 13px;

      
}

/* element  *********************************** */
.projectslist-elementList
{
    color: white;
    font-size:14px;
    
    text-align: left;
    padding-left: 2px;
    padding-right: 2px;
    padding-top: 1px;

      
}
`, "",{"version":3,"sources":["webpack://./src/applications/appcode/appcomponents/projectslist/projectslist.css"],"names":[],"mappings":"AAAA;;IAEI,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;;;IAGI,iDAAiD;IACjD,YAAY;IACZ,mBAAmB;IACnB,WAAW;IACX,yBAAiB;YAAjB,iBAAiB;IACjB,yBAAyB;IACzB,aAAa;IACb,iBAAiB;IACjB,uCAAuC;IACvC,gBAAgB;;;;;;AAMpB;;AAEA;;IAEI,gBAAgB;IAChB,+CAA+C;IAC/C,4BAA4B;IAC5B,6BAA6B;IAC7B,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,kBAAkB;;AAEtB;AACA;;IAEI,WAAW;IACX,6BAA6B;AACjC;AACA;;IAEI,6BAA6B;IAC7B,wBAAwB;IACxB,YAAY;IACZ,gBAAgB;;AAEpB;;;AAGA;;IAEI,iBAAiB;IACjB,mBAAmB;;IAEnB,iDAAiD;IACjD,+BAA+B;IAC/B,gCAAgC;IAChC,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,iBAAiB;;AAErB;;;;;AAKA;;IAEI,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;;IAEI,iBAAiB;IACjB,iBAAiB;IACjB,YAAY;IACZ,YAAY;AAChB;;;AAGA;;IAEI,iBAAiB;IACjB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,mBAAmB,EAAE,+BAA+B;EACtD;;AAEF;IACI,yBAAyB,EAAE,8BAA8B;IACzD,mBAAmB,EAAE,kCAAkC;IACvD,2CAA2C,EAAE,wCAAwC;EACvF;;AAEF;IACI,UAAU;AACd;;AAEA;;IAEI,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ;;AAEJ;;;;AAIA;IACI,mBAAmB,EAAE,+BAA+B;EACtD;;AAEF;IACI,yBAAyB,EAAE,8BAA8B;IACzD,mBAAmB,EAAE,kCAAkC;IACvD,2CAA2C,EAAE,wCAAwC;EACvF;;AAEF;IACI,UAAU;AACd;;;;;;;;AAQA,+DAA+D;AAC/D;IACI,sBAAsB;;IAEtB,WAAW;AACf;;AAEA,uDAAuD;AACvD;;IAEI,yBAAyB;IACzB,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;;IAEhB,kBAAkB;IAClB,YAAY;;;AAGhB;;AAEA,iDAAiD;AACjD;;IAEI,YAAY;IACZ,cAAc;;IAEd,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;;;AAGpB","sourcesContent":[".projectsListFullDiv\n{\n    user-select: none;\n}\n\n.projectsListInterneDiv\n{\n    \n    background-color: var(--dialog-content-backcolor);\n    color: white;\n    border-radius : 8px;\n    width: 100%;\n    user-select: none;\n    height: calc(100% - 60px);\n    border: solid;\n    border-width: 2px;\n    border-color: var(--default-icon-color);\n    margin-top: 10px;\n\n    \n\n    \n\n}\n\n.projectsListTitle\n{\n    padding-top: 5px;\n    background-color: var(--dialog-title-backcolor);\n    border-top-left-radius : 8px;\n    border-top-right-radius : 8px;\n    color: white;\n    height: 30px;\n    font-size: 15px;\n    text-align: center;\n    \n}\n.projectsListTitleCloseButton\n{\n    width: 30px;\n    background-color: transparent;\n}\n.projectsListTitleText\n{\n    background-color: transparent;\n    width: calc(100% - 30px);\n    height: 20px;\n    overflow: hidden;\n\n}\n\n\n.projectsListButtonsDiv\n{\n    padding-top: 10px;\n    padding-bottom: 5px;\n    \n    background-color: var(--dialog-buttons-backcolor);\n    border-bottom-left-radius : 8px;\n    border-bottom-right-radius : 8px;\n    color: white;\n    height: 30px;\n    font-size: 15px;\n    margin-top: 10px;\n    text-align: right;\n    \n}\n\n\n\n\n.projectslist-limit\n{\n    background-color: transparent;\n    margin-top: 5px;\n}\n\n.projectslist-container-header-text\n{\n    display: absolute;\n    overflow-y:hidden;\n    height: 20px;\n    width: 99.6%;\n}\n\n\n.projectslist-container-header\n{\n    display: absolute;\n    height: 20px;\n    width: 99.6%;\n}\n\n.projectslist-container-header::-webkit-scrollbar-track {\n    background: #101010; /* color of the tracking area */\n  }\n  \n.projectslist-container-header::-webkit-scrollbar-thumb {\n    background-color: #151515; /* color of the scroll thumb */\n    border-radius: 20px; /* roundness of the scroll thumb */\n    border: 1px solid var(--default-icon-color); /* creates padding around scroll thumb */\n  }\n\n.projectslist-container-header::-webkit-scrollbar{\n    width:12px;\n}\n\n.projectslist-container\n{\n    overflow-y: scroll;\n    margin-top: 5px;\n    width: 99.7%;\n    height: calc(100% - 85px)\n    \n}\n\n\n\n.projectslist-container::-webkit-scrollbar-track {\n    background: #101010; /* color of the tracking area */\n  }\n  \n.projectslist-container::-webkit-scrollbar-thumb {\n    background-color: #151515; /* color of the scroll thumb */\n    border-radius: 20px; /* roundness of the scroll thumb */\n    border: 1px solid var(--default-icon-color); /* creates padding around scroll thumb */\n  }\n\n.projectslist-container::-webkit-scrollbar{\n    width:12px;\n}\n\n\n\n\n\n\n\n/* ************** projectslist ****************************** */\n.projectslist-projectsList {\n    background-color: blue;\n    \n    width: 100%;\n}\n\n/* element Header *********************************** */\n.projectslist-headerList\n{\n    background-color: #404040;\n    color: white;\n    font-size:14px;\n    text-align: center;\n    padding-left: 2px;\n    padding-right: 2px;\n    padding-top: 1px;\n\n    border-radius: 5px;\n    height: 13px;\n\n      \n}\n\n/* element  *********************************** */\n.projectslist-elementList\n{\n    color: white;\n    font-size:14px;\n    \n    text-align: left;\n    padding-left: 2px;\n    padding-right: 2px;\n    padding-top: 1px;\n\n      \n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
